import React from 'react';
import { TextField, InputAdornment, InputLabel } from '@mui/material';
import { onFormatCardChange } from '../FieldFormat';

const CardInput = (props: { cardStartingValue: string; cardNumberLabel: string; formik: any }): JSX.Element => {
  return (
    <>
      <InputLabel htmlFor={'CardNumber'}>{props.cardNumberLabel}</InputLabel>
      <TextField
        placeholder={'XXX-XXXX-XXX-XXX'}
        required
        fullWidth
        onChange={(event) => onFormatCardChange(event, props.formik.handleChange)}
        type="text"
        name="CardNumber"
        id="CardNumber"
        defaultValue={props.formik.values.CardNumber}
        error={props.formik.touched.CardNumber && Boolean(props.formik.errors.CardNumber)}
        helperText={props.formik.touched.CardNumber && props.formik.errors.CardNumber}
        inputProps={{ maxLength: 16 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" component="div" disablePointerEvents>
              <div
                style={{
                  backgroundColor: '#EEF1F3',
                  marginLeft: '-14px',
                  marginRight: '8px',
                  padding: '16.5px 16px',
                  color: '#5D7181',
                  borderRadius: '5px 0 0 5px',
                  fontSize: '0.875rem',
                }}>
                {props.cardStartingValue}
              </div>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};

export default CardInput;
